<template>
    <v-container style="max-width: 540px" class="px-0">
        <v-text-field
            v-model="search"
            rounded
            solo
            label="Search Instruments"
            placeholder="Search Instruments"
            hide-details
            style="
                border-radius: 36px !important;
                position: sticky;
                top: 0px;
                z-index: 100;
            "
            class="mb-6"
        />
        <v-card class="soli-round pa-1">
            <v-skeleton-loader
                v-if="loading"
                class="mx-auto my-3"
                type="list-item-avatar, list-item-avatar, list-item-avatar"
            ></v-skeleton-loader>
            <v-data-iterator
                :items="getInstruments"
                disable-pagination
                :search="search"
                hide-default-footer
                style="max-height: 36vh; overflow-y: auto; overflow-x: hidden"
                no-results-text=""
            >
                <template v-slot:item="data">
                    <v-list class="py-0 px-2 mb-2 full-round" v-if="!loading">
                        <SoliAvatarBtn
                            @click="
                                [
                                    $emit(
                                        'input',
                                        returnObject ? data.item : data.item.id
                                    ),
                                ]
                            "
                            :avatar="
                                data.item.icon
                                    ? null
                                    : data.item.photo_url
                                    ? `${data.item.photo_url}/m/80x80`
                                    : '/musicologie-m-white.png'
                            "
                            :subtitleBottom="data.item.market"
                            blueShadow
                            :outlined="false"
                            :title="data.item.name"
                            :icon="data.item.icon ?? null"
                            :ripple="true"
                            :append="getDistance ? null : 'chevron_right'"
                            :id="data.item.id"
                        ></SoliAvatarBtn> </v-list></template></v-data-iterator
        ></v-card>
    </v-container>
</template>

<script>
export default {
    components: {},
    props: {
        error: {},
        rules: {},
        autofocus: { type: Boolean, default: false },
        parentInstruments: {
            type: Array,
            default: () => [],
        },
        returnObject: {
            type: Boolean,
            default: true,
        },
    },
    data: function () {
        return {
            instruments: this.parentInstruments,
            loading: false,
            search: null,
            getDistance: false,
            showLocationError: false,
        };
    },
    computed: {
        getInstruments() {
            return [
                { name: "I'm not sure", id: 0, icon: "question_mark" },
                ...this.instruments,
            ];
        },
    },
    mounted() {
        if (this.parentInstruments.length) return;
        this.loading = true;
        axios.get("/api/instruments").then((resp) => {
            this.instruments = resp.data;
            this.loading = false;
        });
    },
};
</script>

<style></style>
